
var initEvents = function () {
    // Flag to track if video has been played
    let videoPlayed = false;
    // Custom video player for product thumbnail
    $('.video-thumbnail-wrapper').parent().addClass('video-thumbnail');

    if ($('.video-thumbnail-wrapper').length > 0) {
        //  Added unique ID to each video elements
        $('.video-thumbnail-wrapper .product-vid').each(function (index, value) {
            $(this).attr('id', 'thumnailvideo_' + index);
        });

        $(document).on('click', '.vid-thumbnail-play-btn', function (e) {
            var video = $('.video-thumbnail-wrapper .product-vid');
            var videoID = $(this).parent().find('.product-vid').attr('id').split('_');
            $('.video-thumbnail-wrapper .vid-thumbnail-play-btn').addClass('in-active');
            $('.video-thumbnail-wrapper img.poster').addClass('in-active');
            $('.video-thumbnail-wrapper video').addClass('active');
            !videoPlayed && video[videoID[1]].play();
        });

        $('.edit-modal .close-button, .reveal-overlay').on('click', function (e) {
           if($(e.target).hasClass('reveal-overlay') || $(e.target).hasClass('icon-close')) {
            var video = $('.video-thumbnail-wrapper .product-vid');
            var videoID = $(this).parent().find('.product-vid').attr('id').split('_');
            $('.video-thumbnail-wrapper .vid-thumbnail-play-btn').removeClass('in-active');
            $('.video-thumbnail-wrapper img.poster').removeClass('in-active');
            $('.video-thumbnail-wrapper video').removeClass('active');
            video[videoID[1]].load();
            video[videoID[1]].pause();
           }
        });

        setTimeout(() => {
            // Custom Video pause on change of thumbnail, Show poster & Play Icon
            var slickSlide = $('.product-image-container #thumbnails .slick-slide');
            var videos = $('.video-thumbnail-wrapper video');

            slickSlide.on('mouseenter', function () {
                customVideoReset();
            });

            $('.product-primary-image .slider-main-image').on('afterChange', function () {
                customVideoReset();
            });

            $('.pdp-main .product-image-container .product-primary-image .slider-main-image .slick-prev, .pdp-main .product-image-container .product-primary-image .slider-main-image .slick-next').on('click', function () {
                customVideoReset();
            });

            function customVideoReset() {
                videoPlayed = false;
                $('.video-thumbnail-wrapper .vid-thumbnail-play-btn').removeClass('in-active');
                $('.video-thumbnail-wrapper img.poster').removeClass('in-active');
                $('.video-thumbnail-wrapper video').removeClass('active');
                videos.each(function (index, video) {
                    video.load();
                    video.pause();
                });
            }
        }, 3000);
    }
}

export default function () {
    initEvents();
};